import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from 'modules/project_management/lib/ContributorsCollectionsBootstrap'

const JobsAndRatesRootPage = () => {
  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default JobsAndRatesRootPage
